<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Số trụ" placeholder="Tìm theo số trụ" v-model="modelSearch.soTru"
                                :isRequire=false @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Tuyến đèn đường" :options="category_TUYENDENDUONG"
                                :initialValue="modelSearch.tuyenDenduongId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.tuyenDenduongId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Loại trụ đèn" :options="category_LOAITRUDEN"
                                :initialValue="modelSearch.loaiTrudenId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.loaiTrudenId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Tình trạng trụ đèn" :options="category_TINHTRANGTRUDEN"
                                :initialValue="modelSearch.tinhtrangTrudenId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.tinhtrangTrudenId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Loại đèn" :options="category_LOAIDEN"
                                :initialValue="modelSearch.loaiDenId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.loaiDenId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Tình trạng đèn" :options="category_TINHTRANGDEN"
                                :initialValue="modelSearch.tinhtrangDenId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.tinhtrangDenId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Công suất đèn" :options="category_CONGSUATDEN"
                                :initialValue="modelSearch.congsuatDenId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.congsuatDenId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false"
                                @onChange="(e) => { modelSearch.enabled = e; handlePageChange(1) }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="currentSearchType == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="currentSearchType == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <TheOpenMapButton :onClickParent="getMapInfoTrudenChieusang" :params="{ chieuSang: false }"></TheOpenMapButton>
                        <TheSwapButton v-model="currentSearchType" @button-clicked="handlePageChange(1)" />
                        <button type="button" class="btn btn-tool" data-toggle="dropdown" :title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.RESTORE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.RESTORE] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.DELETE_TEMP" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE_TEMP] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.DELETE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE] :isDivider="true">
                                    </TheButtonInDropdown>

                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.ON_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.ON_ENABLED] :isDivider="false">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.OFF_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.OFF_ENABLED] :isDivider="true">
                                    </TheButtonInDropdown>
                                </div>
                            </div>
                        </button>
                        <TheCreateButton :onClickParent="() => { detail(null, 'create') }" />
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th style="width:5%">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                    @click="selectAllRows($event)">
                                                <label for="checkboxAll" class="custom-control-label"></label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="cursor col" style="width:5%" @click="handleSortChange('trudenChieusangId')" title="Sắp xếp theo ID">
                                        ID
                                        <span v-if="sortBy == 'trudenChieusangId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" style="min-width: 100px;" @click="handleSortChange('soTru')" title="Sắp xếp theo số trụ">
                                        Số trụ
                                        <span v-if="sortBy == 'soTru'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-2 cursor" @click="handleSortChange('tenTuyenDenduong')" title="Sắp xếp theo tuyến đèn đường">
                                        Tuyến đèn đường
                                        <span v-if="sortBy == 'tenTuyenDenduong'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" @click="handleSortChange('tenLoaiTruden')" title="Sắp xếp theo loại trụ đèn">
                                        Loại trụ đèn
                                        <span v-if="sortBy == 'tenLoaiTruden'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" @click="handleSortChange('tenTinhtrangTruden')" title="Sắp xếp theo tình trạng trụ đèn">
                                        Tình trạng trụ đèn
                                        <span v-if="sortBy == 'tenTinhtrangTruden'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" @click="handleSortChange('tenLoaiDen')" title="Sắp xếp theo loại đèn">
                                        Loại đèn
                                        <span v-if="sortBy == 'tenLoaiDen'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" @click="handleSortChange('tenTinhtrangDen')" title="Sắp xếp theo tình trạng đèn">
                                        Tình trạng đèn
                                        <span v-if="sortBy == 'tenTinhtrangDen'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" @click="handleSortChange('tenCongsuatDen')" title="Sắp xếp theo công suất đèn">
                                        Công suất đèn
                                        <span v-if="sortBy == 'tenCongsuatDen'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="cursor" style="width:5%" @click="handleSortChange('stt')" title="Sắp xếp theo STT">
                                        STT
                                        <span v-if="sortBy == 'stt'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1">Hiển thị trên cổng</th>
                                    <th class="col-1 sticky-action">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td @click="selectRow(item.trudenChieusangId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span v-if="(csList_Navigate.csList.includes(item.trudenChieusangId))" class="text-primary">&check;</span>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                    </td>
                                    <td>{{ item.trudenChieusangId }}</td>
                                    <td>{{ item.soTru }}</td>
                                    <td>{{ item.tenTuyenDenduong }}</td>
                                    <td>{{ item.tenLoaiTruden }}</td>
                                    <td>{{ item.tenTinhtrangTruden }}</td>
                                    <td>{{ item.tenLoaiDen }}</td>
                                    <td>{{ item.tenTinhtrangDen }}</td>
                                    <td>{{ item.tenCongsuatDen }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <TheSwitchInTable 
                                        :placeholder="'Thay đổi hiển thị trên cổng '"
                                        v-model:initialValue="item.enabled" 
                                        :isReadOnly="currentSearchType == typeDataList.DELETED_LIST.id"
                                        :onChange="(e) => { navigateEnabledChange(item.trudenChieusangId, e.target.checked) }"
                                        ></TheSwitchInTable>
                                    </td>
                                    <td class="sticky-action">
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.VIEWDETAILMAP" 
                                            :onClick="getMapInfoTrudenChieusang"
                                            :submitArgs="[item.trudenChieusangId]"
                                            :mapParams="{ chieuSang: false }"
                                            :useChildMethos="true">
                                        </TheButtonInTable>
                                        <TheButtonInTable
                                            v-model="tableButton.VIEWDETAIL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DETAIL]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.EDIT" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.UPDATE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.DELETE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE_TEMP]">
                                        </TheButtonInTable>
                                        
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.DELETE_REAL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.RESTORE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.RESTORE]">
                                        </TheButtonInTable>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <TheCRUDFrameModal ref="modalCRUDRef" idModal="crudModal" dialogClass=" modal-lg" :headerTitle="title"
        :displaySubmit="loadingSubmit" :onSubmit="handleSubmit" :titleSubmit="title" :styleButton="styleButton"
        v-model:showModalFlag="isShowModal.CRUDModal">
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Số trụ" placeholder="Nhập số trụ" :initialValue="model.soTru"
                    v-model="model.soTru" :error="errors.soTru" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <TheSelect title="Tuyến đèn đường" :options="category_TUYENDENDUONG"
                    :initialValue="model.tuyenDenduongId" :error="errors.tuyenDenduongId"
                    :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                    @onChange="(e) => { model.tuyenDenduongId = e }" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheSelect title="Loại trụ đèn" :options="category_LOAITRUDEN"
                    :initialValue="model.loaiTrudenId" :error="errors.loaiTrudenId" :isMultiple="false"
                    :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                    @onChange="(e) => { model.loaiTrudenId = e }" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheSelect title="Tình trạng trụ đèn" :options="category_TINHTRANGTRUDEN"
                    :initialValue="model.tinhtrangTrudenId" :error="errors.tinhtrangTrudenId"
                    :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                    @onChange="(e) => { model.tinhtrangTrudenId = e }" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <TheSelect title="Loại đèn" :options="category_LOAIDEN" :initialValue="model.loaiDenId"
                    :error="errors.loaiDenId" :isMultiple="false" :isReadOnly="isReadOnly"
                    :isAllowClear="true" :isRequire="true" @onChange="(e) => { model.loaiDenId = e }"
                    :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheSelect title="Tình trạng đèn" :options="category_TINHTRANGDEN"
                    :initialValue="model.tinhtrangDenId" :error="errors.tinhtrangDenId" :isMultiple="false"
                    :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                    @onChange="(e) => { model.tinhtrangDenId = e }" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheSelect title="Công suất đèn" :options="category_CONGSUATDEN"
                    :initialValue="model.congsuatDenId" :error="errors.congsuatDenId" :isMultiple="false"
                    :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                    @onChange="(e) => { model.congsuatDenId = e }" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <TheInputText title="GPS Long" placeholder="Nhập gps long" :initialValue="model.gpsLong"
                    v-model="model.gpsLong" :error="errors.gpsLong" :isReadOnly="isReadOnly"
                    :isRequire=false :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="GPS Lat" placeholder="Nhập gps lat" :initialValue="model.gpsLat"
                    v-model="model.gpsLat" :error="errors.gpsLat" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheGetLocationButton v-model:modelValueLat="model.gpsLat"
                    v-model:modelValueLong="model.gpsLong" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Ghi chú" placeholder="Nhập ghi chú"
                    :initialValue="model.ghiChu" v-model="model.ghiChu" :error="errors.ghiChu"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="true"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt" v-model="model.stt"
                    :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-6">
                <TheSwitchButton  title="Hiển thị trên cổng" placeholder="Chọn hiển thị trên cổng" :isReadOnly="isReadOnly" :isRequire=false :key="tempKey" :error="''" v-model:initialValue="model.enabled"> </TheSwitchButton>
            </div>
        </div>
    </TheCRUDFrameModal>

    <TheDetailFrameModal ref="modalDetailRef" idModal="detailModal" dialogClass=""
        :headerTitle="modelRec.soTru" v-model:showModalFlag="isShowModal.detailModal">
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">ID:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tuyenDenduongId }}&nbsp;</b>
                </p>
                <p class="text-sm">Tuyến đèn đường:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenTuyenDenduong }}&nbsp;</b>
                </p>
                <p class="text-sm">Loại trụ đèn:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenLoaiTruden }}&nbsp;</b>
                </p>
                <p class="text-sm">Tình trạng trụ đèn:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenTinhtrangTruden }}&nbsp;</b>
                </p>
                <p class="text-sm">Loại đèn:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenLoaiDen }}&nbsp;</b>
                </p>
                <p class="text-sm">Tình trạng đèn:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenTinhtrangDen }}&nbsp;</b>
                </p>
                <p class="text-sm">Công suất đèn:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenCongsuatDen }}&nbsp;</b>
                </p>
                <p class="text-sm">Công suất đèn:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenCongsuatDen }}&nbsp;</b>
                </p>
                <p class="text-sm">Số trụ:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soTru }}&nbsp;</b>
                </p>
                <p class="text-sm">GPS Long:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.gpsLong }}&nbsp;</b>
                </p>
                <p class="text-sm">GPS Lat:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.gpsLat }}&nbsp;</b>
                </p>
                <p class="text-sm">STT:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                </p>
                <p class="text-sm">Ghi chú:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                </p>
                <p class="text-sm">Hiển thị trên cổng:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                        }}&nbsp;</b>
                </p>
            </div>
        </div>
    </TheDetailFrameModal>
    <TheConfirmDialogModal :title="csList_MapModel.title"
        :confirmLabelButton="csList_MapModel.confirmLabelButton" :onClose="csList_MapModel.onClose"
        :onSubmit="csList_MapModel.onSubmit" :modalContent=csList_MapModel.modalContent
        :isReConfirm=csList_MapModel.isReConfirm :reConfirmMes=csList_MapModel.reConfirmMes
        v-model:showModalFlag="isShowModal.confirmDialogModal"></TheConfirmDialogModal>
    <TheCheckboxConfirmDialogModal :title="csListEnabled_MapModel.title"
        :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton"
        :onClose="csListEnabled_MapModel.onClose" :onSubmit="csListEnabled_MapModel.onSubmit"
        :modalContent=csListEnabled_MapModel.modalContent :key="tempKey"
        :submitArgs="csListEnabled_MapModel.submitArgs" v-model="checkEnable_Memo"
        v-model:showModalFlag="isShowModal.checkBoxConfirmModal">
    </TheCheckboxConfirmDialogModal>



</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import objectDefaultValue from '@/config/object.env'
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import TheSwapButton from '@/components/shareComponents/table/button/TheSwapButton.vue'
import TheOpenMapButton from '@/components/shareComponents/table/button/TheOpenMapButton.vue'
import TheCreateButton from '@/components/shareComponents/table/button/TheCreateButton.vue'
import TheButtonInDropdown from '@/components/shareComponents/table/button/TheButtonInDropdown.vue'
import TheButtonInTable from '@/components/shareComponents/table/button/TheButtonInTable.vue'

import TheGetLocationButton from '@/components/shareComponents/map/TheGetLocationButton.vue'
import TheSwitchButton from '@/components/shareComponents/TheSwitchButton.vue'
import TheDateRangePicker from '@/components/shareComponents/TheDateRangePicker.vue'
import TheDatePicker from '@/components/shareComponents/TheDatePicker.vue'
import TheDetailFrameModal from '@/components/shareComponents/modal/TheDetailFrameModal.vue'
import TheCRUDFrameModal from '@/components/shareComponents/modal/TheCRUDFrameModal.vue'
import TheCheckboxConfirmDialogModal from '@/components/shareComponents/modal/TheCheckboxConfirmDialogModal.vue'
import TheConfirmDialogModal from '@/components/shareComponents/modal/TheConfirmDialogModal.vue'

import TheSwitchInTable from '@/components/shareComponents/table/switch/TheSwitchInTable.vue'

import { truDenChieuSangModel } from '@/models/hethongchieusang/truDenChieuSang.model'
import { tableInteractiveModel } from '@/models/general/tableInteractive.model'

export default {
    name: "TheTruDenChieuSang",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheSwapButton,
        TheOpenMapButton,
        TheCreateButton,
        TheGetLocationButton,
        TheButtonInDropdown,
        TheButtonInTable,
        TheDetailFrameModal,
        TheCRUDFrameModal,
        TheCheckboxConfirmDialogModal,
        TheConfirmDialogModal,
        TheSwitchButton,
        TheSwitchInTable,
        TheDateRangePicker,
        TheDatePicker

    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],
            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: truDenChieuSangModel.newModel(),
            model: truDenChieuSangModel.newFEModel(),
            errors: truDenChieuSangModel.errors(),
            modelSearch: truDenChieuSangModel.newPagingSearchModel(),

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            cEnable_Item: null,
            checkEnable_Memo: false,

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,
            category_LOAITRUDEN: [],
            category_TINHTRANGTRUDEN: [],
            category_LOAIDEN: [],
            category_TINHTRANGDEN: [],
            category_CONGSUATDEN: [],
            category_TUYENDENDUONG: [],
            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            isShowModal: {
                CRUDModal: false,
                detailModal: false,
                checkBoxConfirmModal: false,
                confirmDialogModal: false,
            },
            loadingSubmit: false,
            tempKey: common.randomString(10),

            currentSearchType: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,
            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,
            tableButton: objectDefaultValue.TABLEBUTTON,

        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        ...mapActions('handleData2', ['handleTypeImport', 'handleChangeType', 'formatData']),
        ...mapActions('trudenChieusang', ['getPagingTrudenChieusang', 'getDetailTrudenChieusang', 'getCustomDetailTrudenChieusang', 'checkExistTrudenChieusang', 'createTrudenChieusang', 'updateTrudenChieusang', 'deleteTrudenChieusang', 'restoreTrudenChieusang', 'handleListTrudenChieusang', 'setEnabledTrudenChieusang', 'exportExcelTrudenChieusang', 'getMapInfoTrudenChieusang', 'importExcelTrudenChieusang']),
        ...mapActions('loaiTuyenDuong', ['getBasicLoaiTuyenduong']),
        ...mapActions('loaiTruDen', ['getBasicLoaiTruDen']),
        ...mapActions('tinhTrangTruDen', ['getBasicTinhTrangTruDen']),
        ...mapActions('loaiDen', ['getBasicLoaiDen']),
        ...mapActions('tinhTrangDen', ['getBasicTinhTrangDen']),
        ...mapActions('congsuatDen', ['getBasicCongsuatDen']),
        ...mapActions('tuyenDenduong', ['getBasicTuyenDenduong']),
        async setup() {
            let header = 'Danh sách trụ đèn giao thông'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_LOAITRUDEN = await this.getCategory_LoaiTruDen()
            this.category_TINHTRANGTRUDEN = await this.getCategory_TinhTrangTruDen()
            this.category_LOAIDEN = await this.getCategory_LoaiDen()
            this.category_TINHTRANGDEN = await this.getCategory_TinhTrangDen()
            this.category_CONGSUATDEN = await this.getCategory_CongSuatDen()
            this.category_TUYENDENDUONG = await this.getCategory_TuyenDenDuong()
        },
        //#region TableNavigation
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },
        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.isShowModal.checkBoxConfirmModal = true
        },
        async navigateEnabledChange(id,  value) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                this.updateEnabled()
            }
        },
        async updateEnabled() {
            let model = {
                trudenChieusangId: this.cEnable_Item.id,
                enabled: this.cEnable_Item.enabled
            }
            await this.setEnabledTrudenChieusang({ model: model }).then(async resp => {
                if (resp) {
                    this.isShowModal.checkBoxConfirmModal = false
                }
                else {
                    const itemIndex = this.items.findIndex(item => item.trudenChieusangId === this.cEnable_Item.id);
                    if (itemIndex !== -1) {
                        this.items[itemIndex].enabled = !this.items[itemIndex].enabled;

                    } else {
                        await this.getData()
                    }
                }

            });
        },
        async closeConfirmEnabledChange() {
            const itemIndex = this.items.findIndex(item => item.trudenChieusangId === this.cEnable_Item.trudenChieusangId);
            if (itemIndex !== -1) {
                this.items[itemIndex].enabled = !this.items[itemIndex].enabled;
            } else {
                await this.getData()
            }
            this.isShowModal.checkBoxConfirmModal = false
        },
        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },
        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async unSelectAllRows() {
            this.csList_Navigate.csList = []
            document.getElementById("checkboxAll").checked = false
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.trudenChieusangId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            if (this.modelSearch.soTru == "") this.modelSearch.soTru = null
            this.modelSearch.chieuSang = false
            this.modelSearch.enabled = await this.handleChangeType({ input: this.modelSearch.enabled, typeChange: objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN })
        },
        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()
            await this.unSelectAllRows()
            await this.getPagingTrudenChieusang({ params: this.modelSearch, type: this.currentSearchType }).then(res => {
                // List data
                this.items = res.data
                this.totalRow = res.totalRow
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },
        //#endregion TableNavigation
        //#region CRUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = truDenChieuSangModel.errors()
            this.loadingSubmit = false

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    trudenChieusangId: item.trudenChieusangId
                }
                await this.getDetailTrudenChieusang({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = truDenChieuSangModel.newModel()
                        this.modelRec = resp
                        this.model = truDenChieuSangModel.parseModeltoFEModel(this.modelRec)

                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    trudenChieusangId: item.trudenChieusangId
                }
                await this.getDetailTrudenChieusang({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = truDenChieuSangModel.newModel()
                        this.modelRec = resp

                    }
                });
                this.tempKey = common.randomString(10)
                this.isShowModal.detailModal = true
            }
            else {
                this.model = truDenChieuSangModel.newFEModel()
                this.isReadOnly = false
                // show popup
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistTrudenChieusang({ params: params })
            return res.data
        },
        async validate(model) {
            let isvalid = true
            this.errors = truDenChieuSangModel.errors()
            if (!await this.validateRequired(model.soTru)) {
                this.errors.soTru = "Nhập số trụ"
                isvalid = false
            }
            else if (this.code == this.navigateCode.UPDATE && this.modelRec.soTru != model.soTru) {
                if (await this.checkExistName(model.ten)) {
                    this.errors.soTru = "Số trụ này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            else if (this.code == this.navigateCode.CREATE) {
                if (await this.checkExistName(model.soTru)) {
                    this.errors.ten = "Số trụ này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }

            if (!await this.validateRequired(model.tuyenDenduongId)) {
                this.errors.tuyenDenduongId = "Chọn tuyến đèn đường"
                isvalid = false
            }

            if (!await this.validateRequired(model.loaiDenId)) {
                this.errors.loaiDenId = "Chọn loại đèn"
                isvalid = false
            }
            if (!await this.validateRequired(model.tinhtrangDenId)) {
                this.errors.tinhtrangDenId = "Chọn tình trạng đèn"
                isvalid = false
            }
            if (!await this.validateRequired(model.loaiTrudenId)) {
                this.errors.loaiTrudenId = "Chọn loại trụ đèn"
                isvalid = false
            }
            if (!await this.validateRequired(model.tinhtrangTrudenId)) {
                this.errors.tinhtrangTrudenId = "Chọn tình trạng trụ đèn"
                isvalid = false
            }
            if (!await this.validateRequired(model.congsuatDenId)) {
                this.errors.congsuatDenId = "Chọn công suất đèn"
                isvalid = false
            }

            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }
            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = truDenChieuSangModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.trudenChieusangId = FEmodel.trudenChieusangId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.trudenChieusangId = FEmodel.trudenChieusangId
                sendModel.soTru = FEmodel.soTru
                sendModel.tuyenDenduongId = FEmodel.tuyenDenduongId
                sendModel.loaiDenId = FEmodel.loaiDenId
                sendModel.tinhtrangDenId = FEmodel.tinhtrangDenId
                sendModel.loaiTrudenId = FEmodel.loaiTrudenId
                sendModel.tinhtrangTrudenId = FEmodel.tinhtrangTrudenId
                sendModel.congsuatDenId = FEmodel.congsuatDenId

                sendModel.gpsLong = FEmodel.gpsLong
                sendModel.gpsLat = FEmodel.gpsLat
                sendModel.ghiChu = FEmodel.ghiChu
                sendModel.stt = FEmodel.stt
                sendModel.enabled = FEmodel.enabled ? FEmodel.enabled : false
            }
            return sendModel
        },
        async handleSubmit() {
            if (this.code === this.navigateCode.DELETE) {
                this.csList_MapModel = {
                    title: this.$t('labels.confirmDelete'),
                    confirmLabelButton: this.$t('buttons.confirm'),
                    onClose: null,
                    onSubmit: this.onSubmit,
                    modalContent: "<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>",
                }
                this.isShowModal.confirmDialogModal = true
            }
            else {
                await this.onSubmit()
            }
        },
        async onSubmit() {
            this.loadingSubmit = true
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createTrudenChieusang({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateTrudenChieusang({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteTrudenChieusang({ model: sendModel, type: this.currentSearchType })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteTrudenChieusang({ model: sendModel, type: this.currentSearchType })
                    if (res) this.isShowModal.confirmDialogModal = false
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreTrudenChieusang({ model: sendModel })
                    break
                default:
            }
            if (res) {
                this.isShowModal.CRUDModal = false
                await this.getData()
            }

            this.loadingSubmit = false
        },
        //#endregion CRUD
        //#region ListNavigation
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                let tempReConfirmMes = code == this.navigateCode.DELETE ?"<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>những dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>" : null
                this.csList_MapModel = {
                    isReConfirm: code == this.navigateCode.DELETE ? true : false,
                    reConfirmMes: tempReConfirmMes,
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: null,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.isShowModal.confirmDialogModal = true
            }
        },

        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            let res = null
            if (code == objectDefaultValue.NAVIGATECODE_VALUE.DELETE) {
                res = await this.handleListTrudenChieusang(modelSend)
            }
            else {
                res = await this.handleListTrudenChieusang(modelSend)
            }
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.isShowModal.confirmDialogModal = false
            }
        },
        //#endregion ListNavigation

        async getCategory_LoaiTruDen() {
            let params = {
                chieuSang: false
            }
            let res = await this.getBasicLoaiTruDen({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].loaiTrudenId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_TinhTrangTruDen() {
            let params = {
            }
            let res = await this.getBasicTinhTrangTruDen({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].tinhtrangTrudenId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_LoaiDen() {
            let params = {
                chieuSang: false
            }
            let res = await this.getBasicLoaiDen({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].loaiDenId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_TinhTrangDen() {
            let params = {
            }
            let res = await this.getBasicTinhTrangDen({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].tinhtrangDenId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_CongSuatDen() {
            let params = {
                chieuSang: false
            }
            let res = await this.getBasicCongsuatDen({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].congsuatDenId,
                            name: res[i].ten
                        }
                    )
                }

                return handleRes
            }
            return []
        },

        async getCategory_TuyenDenDuong() {
            let params = {
                chieuSang: false
            }
            let res = await this.getBasicTuyenDenduong({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].tuyenDenduongId,
                            name: res[i].ten
                        }
                    )
                }

                return handleRes
            }
            return []
        },



    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style>
</style>
